import { useState } from 'react';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import CommonIcon from '../CommonIcon';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';
import Styles from './mIndex.module.scss';

export interface IMenuListItem {
  key: string,
  text: string,
  disabled?: boolean,
}

export interface ICommonDropdownProps {
  className?: string;
  menuList: IMenuListItem[];
  leftTriggerNode?: React.ReactNode;
  rightTriggerNode?: React.ReactNode;
  getPopupContainer?: () => HTMLElement;
  onSelectMenu: (key: string) => void;
  activeKey?: string;
}

const CommonDropdown = ({
  className = '',
  menuList,
  leftTriggerNode,
  rightTriggerNode,
  getPopupContainer,
  onSelectMenu,
  activeKey
}: ICommonDropdownProps) => {
  const t = useTranslations();

  const [visible, setVisible] = useState<boolean>(false);

  const onSelect = ({ key }: { key: string }) => {
    setVisible(false);
    onSelectMenu(key);
  }
  
  const onVisibleChange = (visible: boolean) => {
    setVisible(visible);
  }

  const menu = (
    <Menu onClick={onSelect} activeKey={activeKey}>
      {
        menuList?.map((item) => (
          <MenuItem key={item.key} disabled={item.disabled} className={cx(item.key === activeKey && Styles.activeMenuItem)}>{item.text}</MenuItem>
        ))
      }
    </Menu>
  );

  return (
    <div className={cx(Styles.root, className)} id='common-dropdown'>
      <Dropdown
        trigger={['click']}
        overlayClassName='commonDropdownMenu'
        overlay={!!menuList?.length ? menu : (<span className='common-dropdown-no-data'>{t('dropdown_menu_empty')}</span>)}
        visible={visible}
        placement="bottomRight"
        getPopupContainer={getPopupContainer || (() => document.getElementById('common-dropdown') as HTMLElement)}
        onVisibleChange={onVisibleChange}
      >
        <div className={cx(Styles.trigger)}>
          {leftTriggerNode ? leftTriggerNode : (
            <div className={cx(Styles.leftIcon, {[Styles.leftIconMargin]: !!rightTriggerNode, [Styles.leftIconTop]: visible})}>
              <CommonIcon icon="arrow-extend" />
            </div>
          )}
          {rightTriggerNode && rightTriggerNode}
        </div>
      </Dropdown>
    </div>
  );
};

export default CommonDropdown;
